import {
  ROLEFORM_FETCHITEM_LOAD,
  ROLEFORM_FETCHITEM_SUCCEED,
  ROLEFORM_FETCHITEM_FAIL,
  ROLEFORM_EDITFORM_CHANGE,
  ROLEFORM_ENTER_RESET,
  ROLEFORM_CREATEITEM_LOAD,
  ROLEFORM_CREATEITEM_SUCCEED,
  ROLEFORM_CREATEITEM_FAIL,
  ROLEFORM_EDITITEM_LOAD,
  ROLEFORM_EDITITEM_SUCCEED,
  ROLEFORM_EDITITEM_FAIL,
  ROLEFORM_DELETEITEM_LOAD,
  ROLEFORM_DELETEITEM_SUCCEED,
  ROLEFORM_DELETEITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case ROLEFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case ROLEFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case ROLEFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case ROLEFORM_ENTER_RESET:
      return {}
    case ROLEFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case ROLEFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case ROLEFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case ROLEFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case ROLEFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case ROLEFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case ROLEFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case ROLEFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case ROLEFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case ROLEFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/roleForm.js